import { createAsyncThunk } from '@reduxjs/toolkit';
import { GlobalFeatureNameSpaceNotary } from '../../../common/globalNotary';
import ApiService from '../../../common/ApiCalls';

export const fetchUserDetails = createAsyncThunk(
  GlobalFeatureNameSpaceNotary.USERS + '/userDetailsFetch',
  async () => {
    const res = await ApiService().loginInfo();

    if (res && res.status === 200 && res.data) {
      return {
        avatar: res.data.avatar,
        userId: res.data.user_id,
        email: res.data.email
      };
    }

    return null;
  },
  {
    condition: (arg, { getState }) => {
      const { users } = getState();
      return !users.isLoading;
    }
  }
);
